import { api } from 'utils/hooks/useApi';
import { get } from 'lodash';
import { IAnonymizationProfile } from './_types';

export const getAnonymizationProfiles = (): Promise<IAnonymizationProfile[] | false> =>
  api()
    .get(`/portal-api/anonymization/getProfiles`)
    .then((response) => get(response, 'data'))
    .catch((error) => false);
